import {
  faTowerObservation,
  faHome,
  faUser,
  faBuilding,
  faBullseye,
  faExclamationTriangle,
  faArrowTurnUp,
  faCircleDollarToSlot,
  faLineChart,
  faChartColumn,
  faEye,
  faUserCircle,
  faFile,
  faClipboard,
  faArrows,
  faBoltLightning,
  faArrowRightFromBracket,
  faChartBar,
  faBarChart,
  faGlasses,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SubMenu, MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import { TSLandingPage } from "../components/TSLandingPage";
import { Page } from "@thoughtspot/visual-embed-sdk";
import { AppEmbedWrapper } from "../components/AppEmbed/AppEmbedWrapper";
import { GenericLiveboardEmbed } from "../components/GenericLiveboardEmbed";
import Layout from "../components/Layout";
import SecureRoute from "../components/SecureRoute";
import { DefaultSidebarBreakpoint } from "../components/SidebarToggle";
import { appEmbedWrapperCssRules } from "../cssRules";
import { ContactUs } from "../pages/contactus/ContactUs";
import { HeatmapPerformanceMetrics } from "../pages/demos/chm/HeatmapPerformanceMetrics";
import { TablePerformanceMetrics } from "../pages/demos/chm/TablePerformanceMetrics";
import { CashFlowWalk } from "../pages/demos/rocket-demo/CashFlowWalk";
import { ProfitabilityWalk } from "../pages/demos/rocket-demo/ProfitabilityWalk";
import { RocketBalanceSheet } from "../pages/demos/rocket-demo/RocketBalanceSheet";
import { RocketIncomeStatement } from "../pages/demos/rocket-demo/RocketIncomeStatement";
import { SignOut } from "../pages/sign-out/SignOut";
import {
  SubdomainOrgIdObject,
  subMenuDefaultProps,
} from "./FunctionsAndInterfaces";
import { FinancialModeling } from "../pages/demos/rocket-demo/FinancialModeling";

const orgId: number = 1977935901;
const subDomain: string = "demo";
const nameOfProduct: string = "Demo";
const secureRouteGroups: string[] = ["Demo"];

export const demoObject: SubdomainOrgIdObject = {
  orgID: orgId,
  path: subDomain,
};

export const demoLandingPage = (
  <TSLandingPage
    parentURL={`/${subDomain}`}
    smallButtons={true}
    buttons={[
      [
        {
          title: "Financials",
          titleSettings: { isTitle: true, isBigTitle: true },
        },
        {
          title: "CEO Summary",
          backgroundImageName: "/CFO.png",
          description: "",
          link: "ceosummary",
          internal: true,
        },
        {
          title: "CFO Summary",
          backgroundImageName: "/Money.png",
          description: "",
          link: "cfosummary",
          internal: true,
        },
        {
          title: "Channel P&L",
          backgroundImageName: "/PL.png",
          description: "",
          link: "channelpl",
          internal: true,
        },
        {
          title: "Income Statement",
          backgroundImageName: "/Income.png",
          description: "",
          link: "incomestatement",
          internal: true,
        },
        {
          title: "Cash Flow",
          backgroundImageName: "/CashFlow.png",
          description: "",
          link: "cashflow",
          internal: true,
        },
        {
          title: "Balance Sheet",
          backgroundImageName: "/Balance.png",
          description: "",
          link: "balancesheet",
          internal: true,
        },
        {
          title: "Profitability Walk",
          backgroundImageName: "/ProfitabilityWalk.png",
          description: "",
          link: "profitabilitywalk",
          internal: true,
        },
      ],
      [
        {
          title: "Originations",
          titleSettings: { isTitle: true, isBigTitle: true },
        },
        {
          title: "Retail Lending Analytics",
          backgroundImageName: "",
          description: "",
          link: "retaillendinganalytics",
          internal: true,
        },
        {
          title: "AE Summary",
          backgroundImageName: "",
          description: "",
          link: "aeheatmap",
          internal: true,
        },
        {
          title: "AE Scoreboard",
          backgroundImageName: "",
          description: "",
          link: "aescoreboard",
          internal: true,
        },
        {
          title: "Branch Demo",
          backgroundImageName: "",
          description: "",
          link: "branchdemo",
          internal: true,
        },
      ],
      [
        {
          title: "Forecasting",
          titleSettings: { isTitle: true, isBigTitle: true },
        },
        {
          title: "Model",
          backgroundImageName: "/Chart1.png",
          description: "",
          link: "model",
          internal: true,
        },
      ],
      [
        {
          title: "Gallus Search",
          titleSettings: { isTitle: true, isBigTitle: true },
        },
        {
          title: "Search",
          backgroundImageName: "/MagnifyingGlass.png",
          description: "",
          link: "search",
          internal: true,
        },
      ],
    ]}
  />
);

const sidebarMenu = () => {
  return (
    <>
      <SubMenu
        {...subMenuDefaultProps}
        title={"Demo"}
        icon={<FontAwesomeIcon className="me-2" icon={faTowerObservation} />}
      >
        <MenuItem>
          <Link to={`/${subDomain}/`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faHome} />
              Menu
            </div>
          </Link>
        </MenuItem>
      </SubMenu>
      <SubMenu
        {...subMenuDefaultProps}
        title={"Financials"}
        icon={<FontAwesomeIcon className="me-2" icon={faUser} />}
      >
        <MenuItem>
          <Link to={`/${subDomain}/ceosummary`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faBuilding} />
              CEO Summary
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/cfosummary`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faBullseye} />
              CFO Summary
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/channelpl`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faExclamationTriangle} />
              Channel P&L
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/incomestatement`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faArrowTurnUp} />
              Income Statement
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/cashflow`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faCircleDollarToSlot} />
              Cashflow
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/balancesheet`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faLineChart} />
              Balance Sheet
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/profitabilitywalk`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faChartColumn} />
              Profitability Walk
            </div>
          </Link>
        </MenuItem>
      </SubMenu>
      <SubMenu
        {...subMenuDefaultProps}
        title={"Originations"}
        icon={<FontAwesomeIcon className="me-2" icon={faEye} />}
      >
        <MenuItem>
          <Link to={`/${subDomain}/retaillendinganalytics`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faUserCircle} />
              Retail Lending Analytics
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/aeheatmap`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faFile} />
              AE Summary
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/aescoreboard`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faClipboard} />
              AE Scoreboard
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/branchdemo`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faArrows} />
              Branch Demo
            </div>
          </Link>
        </MenuItem>
      </SubMenu>
      <SubMenu
        {...subMenuDefaultProps}
        title={"Marketing"}
        icon={<FontAwesomeIcon className="me-2" icon={faBoltLightning} />}
      >
        <MenuItem>
          <Link to={`/${subDomain}/marketingagencyanalyticsdemo`}>
            <div className="sidebar-item">
              <FontAwesomeIcon
                className="me-2"
                icon={faArrowRightFromBracket}
              />
              Marketing Agency Analytics Demo
            </div>
          </Link>
        </MenuItem>
      </SubMenu>
      <SubMenu
        {...subMenuDefaultProps}
        title={"Forecasting"}
        icon={<FontAwesomeIcon className="me-2" icon={faChartBar} />}
      >
        <MenuItem>
          <Link to={`/${subDomain}/model`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faBarChart} />
              Model
            </div>
          </Link>
        </MenuItem>
      </SubMenu>
      <SubMenu
        {...subMenuDefaultProps}
        title={"Gallus Search"}
        icon={<FontAwesomeIcon className="me-2" icon={faGlasses} />}
      >
        <MenuItem>
          <Link to={`/${subDomain}/Search`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faSearch} />
              Search
            </div>
          </Link>
        </MenuItem>
      </SubMenu>
    </>
  );
};

export const demoRoutes = {
  element: (
    <Layout
      breakPoint={DefaultSidebarBreakpoint}
      smallHeader={true}
      sidebarMenu={sidebarMenu()}
      contactUsPath={`/${subDomain}/contactus`}
      signOutPath={`/${subDomain}/signout`}
    />
  ),
  children: [
    {
      path: `/${subDomain}`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={demoLandingPage}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/ceosummary`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <GenericLiveboardEmbed
              enablePremiumFeatures={true}
              description="CEO Summary"
              guid="0f6b5102-d7ba-439d-ade2-f103153c358a"
              orgID={orgId}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/cfosummary`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <GenericLiveboardEmbed
              enablePremiumFeatures={true}
              description="CFO Summary"
              guid="1797d4e7-4059-4c65-9755-b7fd65427a7f"
              orgID={orgId}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/channelpl`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <GenericLiveboardEmbed
              enablePremiumFeatures={true}
              description="Channel P&L"
              guid="f49a8a3b-d623-4920-914c-743226903850"
              orgID={orgId}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/incomestatement`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<RocketIncomeStatement />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/cashflow`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<CashFlowWalk />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/balancesheet`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<RocketBalanceSheet />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/profitabilitywalk`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<ProfitabilityWalk />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/model`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<FinancialModeling />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/retaillendinganalytics`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <GenericLiveboardEmbed
              enablePremiumFeatures={true}
              description="Retail Lending Analytics"
              guid="31f70534-e614-4832-8888-5b99f92c4e16"
              orgID={orgId}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/aeheatmap`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <HeatmapPerformanceMetrics
              scope="Account Executive"
              useDemoData={true}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/aescoreboard`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <TablePerformanceMetrics
              addTotalsToCSV={true}
              scope="Account Executive"
              useDemoData={true}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/marketingagencyanalyticsdemo`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <GenericLiveboardEmbed
              enablePremiumFeatures={true}
              description="Marketing Agency Analytics Demo"
              guid="645ac39f-52fa-41e0-854f-0802c213974c"
              orgID={1588809781}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/branchdemo`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <GenericLiveboardEmbed
              enablePremiumFeatures={true}
              description="Branch Demo"
              guid="3de8ef23-3478-4308-83e9-ad1059267cb9"
              orgID={orgId}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/search`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <AppEmbedWrapper
              cssRules={appEmbedWrapperCssRules}
              breakPoint={DefaultSidebarBreakpoint}
              enableFullFeatures={true}
              showPrimaryNavbar={true}
              defaultPage={Page.Search}
              disableProfileAndHelp={true}
              className="ts-full-app h-100"
              orgObject={demoObject}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/contactus`,
      element: <ContactUs />,
    },
    {
      path: `/${subDomain}/signout`,
      element: <SignOut />,
    },
  ],
};
